import { render, staticRenderFns } from "./OrderAgainDialog.vue?vue&type=template&id=a6d9f940&"
import script from "./OrderAgainDialog.vue?vue&type=script&setup=true&lang=js&"
export * from "./OrderAgainDialog.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./OrderAgainDialog.vue?vue&type=style&index=0&id=a6d9f940&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QDialog});
